"use client";

import { useCallback, useEffect, useState } from "react";
import {
	DEFAULT_PAGES_VISIBILITY,
	type PagesVisibility,
} from "@/types/site-settings";
import { useSiteSettings } from "@/components/shared/site-settings-provider";

const BACKEND = (process.env.NEXT_PUBLIC_BACKEND_URL || "").replace(/\/+$/, "");

export async function fetchPagesVisibility(): Promise<PagesVisibility> {
	if (!BACKEND) return DEFAULT_PAGES_VISIBILITY;
	try {
		const res = await fetch(`${BACKEND}/api/site-settings`, {
			cache: "no-store",
		});
		if (!res.ok) return DEFAULT_PAGES_VISIBILITY;
		const data = await res.json();
		return { ...DEFAULT_PAGES_VISIBILITY, ...data.pages };
	} catch {
		return DEFAULT_PAGES_VISIBILITY;
	}
}

export function usePagesVisibility() {
	return useSiteSettings();
}

export function notifyPagesVisibilityChanged() {
	window.dispatchEvent(new Event("site-settings:changed"));
}

/** Fallback per componenti fuori dal provider (non usare in layout principale). */
export function usePagesVisibilityStandalone() {
	const [pages, setPages] = useState<PagesVisibility>(DEFAULT_PAGES_VISIBILITY);
	const [loading, setLoading] = useState(true);

	const refresh = useCallback(async () => {
		setPages(await fetchPagesVisibility());
		setLoading(false);
	}, []);

	useEffect(() => {
		void refresh();
		const onChange = () => void refresh();
		window.addEventListener("site-settings:changed", onChange);
		return () => window.removeEventListener("site-settings:changed", onChange);
	}, [refresh]);

	return { pages, loading, refresh };
}
